import type { ReactNode } from 'react'
import { MantineProvider } from '@mantine/core'
import { ThemeContextProvider } from './ThemeContext'
import { useTheme } from './useTheme'
import { lightTheme, darkTheme } from './mantineTheme'

// No <Notifications /> here. Each app mounts its own, once, in main.tsx, beside the comment saying why it must be there.
// This provider mounted one too, and Mantine renders every notification in every mounted host, so each toast in both
// SPAs appeared twice.
function ThemeProviderInner({ children }: { children: ReactNode }) {
  const { mode } = useTheme()

  return (
    <MantineProvider theme={mode === 'dark' ? darkTheme : lightTheme} forceColorScheme={mode}>
      {children}
    </MantineProvider>
  )
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeContextProvider>
      <ThemeProviderInner>{children}</ThemeProviderInner>
    </ThemeContextProvider>
  )
}
